import { createEntityBundle } from '@common/utils'

const unitBundle = createEntityBundle({
  name: 'units',
})

export default unitBundle
